// import React, { useState, useEffect } from 'react';
// import  AdminMainContent  from './Admin-routing';
// import  AdminSidebar  from './Admin-sidebar';
// import AdminHeader from './Admin-header';
// import '../../App.css';
// import '../../Styles/Admin-dashboard.css';
// import { useLocation, useNavigate } from 'react-router-dom';
// // import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// // import CreatePanel from './Admin-CreatePanel';


// function AdminDashboard() {

//     const navigate = useNavigate();

//     useEffect(() => {
//         const token = sessionStorage.getItem("token");
//         if (!token) {
//         navigate('/Admin');
//         }
//     }, [navigate]);
//     const [selectedComponent, setSelectedComponent] = useState(null);
//     const [dataToSend, setDataToSend] = useState(null);
//     const [collapseSidebar, setcollapseSidebar] = useState(false);

//     const sendDataToTarget = (data) => {
//         // Handle the data as needed
//         //console.log('Data sent to target admin.js:', data);
//         if (data) {
//             setcollapseSidebar((prevcollapseSidebar) => !prevcollapseSidebar);
//         }
//         setDataToSend(data);
//     };
//     const location = useLocation();
//     const handleComponentSelect = (component) => {

//         setSelectedComponent(component);

//     };
//     if (selectedComponent == null) {
//         let href = location.pathname.split('/')[2]
//         setSelectedComponent(href)
//     }

//     return (
//         <div className="">
//             <div className=''>
//                 <AdminHeader sendDataToTarget={sendDataToTarget} handleComponentSelect={handleComponentSelect} />
//             </div>
//             <div className='dashboard-mainContent' >
//                 <div className={!collapseSidebar ? 'collapse-sidebar-deskop' : 'collapse-sidebar-deskop-expand'}>
//                     <AdminSidebar dataReceived={dataToSend} handleComponentSelect={handleComponentSelect} />
//                 </div>
//                 <div className={!collapseSidebar ? 'mainContent' : 'mainContent-expand'}>
//                     <AdminMainContent selectedComponent={selectedComponent} handleComponentSelect={handleComponentSelect} />

//                 </div>

//             </div>
//         </div>
//     );
// }

// export default AdminDashboard;
// import React, { useState, useEffect } from 'react';
// import AdminMainContent from './Admin-routing';
// import NewSidebar from './Admin-Newsidebar';
// import AdminHeader from './Admin-header';
// import '../../App.css';
// import '../../Styles/Admin-dashboard.css';
// import { useLocation, useNavigate } from 'react-router-dom';

// function AdminDashboard() {
//     const navigate = useNavigate();

//     useEffect(() => {
//         const token = sessionStorage.getItem("token");
//         if (!token) {
//             navigate('/Admin');
//         }
//     }, [navigate]);

//     const [selectedComponent, setSelectedComponent] = useState(null);

//     const location = useLocation();
//     const handleComponentSelect = (component) => {
//         setSelectedComponent(component);
//     };

//     // Initialize selected component based on URL path
//     if (selectedComponent == null) {
//         const href = location.pathname.split('/')[2];
//         setSelectedComponent(href);
//     }

//     return (
//         <div className="dashboard-container">
//             <div>
//                 <AdminHeader handleComponentSelect={handleComponentSelect} />
//             </div>
//             <div className="dashboard-mainContent">
//                 <div className="sidebar">
//                 <div>
//             <NewSidebar 
//                 handleComponentSelect={handleComponentSelect} // Pass tabClick function
//             />
//         </div>
//                 </div>
//                 <div className="mainContent">
//                     <AdminMainContent
//                         selectedComponent={selectedComponent}
//                         handleComponentSelect={handleComponentSelect}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default AdminDashboard;


import React, { useState, useEffect } from 'react';
import AdminMainContent from './Admin-routing';
import NewSidebar from './Admin-Newsidebar';
import AdminHeader from './Admin-header';
import '../../App.css';
import '../../Styles/Admin-dashboard.css';
import { useLocation, useNavigate } from 'react-router-dom';

function AdminDashboard() {
    const navigate = useNavigate();
    const [activeFlag, setActiveFlag] = useState('');

    // Check for authentication token
    useEffect(() => {
        const token = sessionStorage.getItem("token");
        if (!token) {
            navigate('/Admin');
        }
        const activeLink = sessionStorage.getItem("activeLink")
        if (activeLink) {
            setActiveFlag(activeLink);
        }
    }, [navigate]);


    const [selectedComponent, setSelectedComponent] = useState(null);
    const [collapseSidebar] = useState(false);
    const [collapseSideSidebar] = useState(false)// Manage sidebar state

    const location = useLocation();
    const handleComponentSelect = (component) => {
        setSelectedComponent(component);
    };

    // Initialize selected component based on URL path
    if (selectedComponent == null) {
        const href = location.pathname.split('/')[2];
        setSelectedComponent(href);
    }

    return (
        <div className="dashboard-container">
            <div
                className={`dashboard-header ${activeFlag === 'analytics' ? 'analytics-header' : ''
                    }`}
            >
                <AdminHeader handleComponentSelect={handleComponentSelect} />
            </div>
            <div className="totalContainer">
                <div className="d-flex flex-container">
                    {activeFlag !== 'analytics' && (
                        <div
                            className={`collapse-sidebar-deskop ${collapseSidebar ? 'collapse-sidebar-deskop-expand' : ''
                                } ${collapseSideSidebar ? 'collapse-sidebar-sidemenuhide' : ''
                                }`}
                        >
                            <NewSidebar handleComponentSelect={handleComponentSelect} />
                        </div>
                    )}
                    <div
                        className={`h-100 ${activeFlag === 'analytics'
                                ? 'mainContent-fullscreen'
                                : collapseSidebar
                                    ? 'mainContent-expand'
                                    : 'mainContent'
                            }`}
                    >
                        <div className="row h-100">
                            <div className="col-lg-12 col-md-12 col-12 p-0 main-content-loader">
                                <AdminMainContent
                                    selectedComponent={selectedComponent}
                                    handleComponentSelect={handleComponentSelect}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default AdminDashboard;